import axios from "axios";
import config from "../Config.json";

const getAccessRoles = async () => {
    try {
        axios.defaults.headers.common['Authorization'] = localStorage.getItem('token');
        const response = await axios.get(`${config.API_URL}/app/getAccessRoles`);
        return response
    } catch (error) {
        return error
    }
}

export default getAccessRoles;